<template>
  <li href="#drawer-messages-chat" class="dashboard-thread-list-item" :data-toggle="$chatsModuleEnabled ? 'drawer' : null" aria-foldedopen="false" aria-controls="drawer-messages-chat" @click="handleGetThreadCallback">
    <a>
      <div class="row booking-thread-list-item">
        <div class="col-xs-12 col-sm-1 participants-container">
          <img v-for="(p, index) in participantsAvatars" :key="p.id" :src="p.avatar" :style="{left: (index * 15) + 'px', 'z-index': participantsAvatars.length - index }">
        </div>
        <div class="col-xs-12 col-sm-7">
          <h3 class="chat-lead">
            {{ participantsNames }}
          </h3>
          <div v-if="$chatsModuleEnabled">
            <span v-if="thread.latest_message">
              <span :class="this.thread.unread_count ? 'unread-messages' : 'chat-sub message-text'">
                {{ messageName }}: {{ thread.latest_message.file ? 'File Uploaded' : thread.latest_message.text }}
              </span>
              <span class="pull-right" :class="this.thread.unread_count ? 'unread-messages' : 'chat-sub message-text'">
                {{ messageTimestamp }}
                <span v-if="this.thread.unread_count && !$userIsAdmin" class="unread-circle pull-right">
                  &nbsp;
                </span>
                <span v-if="this.thread.unread_count && $userIsAdmin" class="pull-right">
                  &nbsp;| {{ this.thread.unread_count}} unread
                </span>
              </span>
            </span>
            <span v-else>
              <span class="chat-sub message-text">No Messages</span>
            </span>
          </div>
        </div>
        <div v-if="$chatsModuleEnabled" class="col-xs-12 col-sm-3 messaging-flex-box spacer-y-1">
          <button
            type="button"
            class="btn btn-info btn-sm pull-right thread-list-item-button w-full">
            <span>
              {{ threadButton }}
            </span>
          </button>
        </div>
      </div>
    </a>
  </li>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { helpers } from 'mixins/messages'
import { helpers as bookingHelpers } from 'mixins/bookings'
import { ChatTracker } from 'mixins/analytics'

export default {
  mixins: [helpers, bookingHelpers, ChatTracker],

  props: {
    thread: {
      required: true,
      type: Object
    },
    booking: {
      required: true,
      type: Object
    }
  },

  computed: {
    ...mapState('clientConfig', ['client_config'])
  },

  methods: {
    ...mapActions('booking/file', ['storeBookingFile', 'destroyFile', 'downloadFile']),
    ...mapActions('message', ['getThread']),
    ...mapActions('booking', ['bookingThreadUnreadCount']),

    handleGetThreadCallback () {
      if (this.$chatsModuleEnabled) {
        this.trackEvent(this.analytics.V2.JobChatOpenEvent)
        const targetElement = document.getElementById('mainbody')
        targetElement.style.overflow = 'hidden'
        return this.getThread({ threadId: this.thread.id, userId: this.$user.id, tenantSlug: this.client_config.slug })
          .then(() => {
            this.bookingThreadUnreadCount({ threadId: this.thread.id, count: 0 })
          })
      }
    }
  }
}
</script>
